<div class="loader-container" fxLayout="row" fxLayoutAlign="center center">
  <img id="loader" class="rotate" src="assets/img/loader.png" alt="" />
</div>
